<ng-container *ngIf="tokenValid === true; else CheckOtherConditionsTmpl">
  <div class="digital-signature-cntr">

      <img *ngIf="companyLogoSrc; else logoSkeletonTmpl" alt="homepage" [src]="companyLogoSrc" height="55" />

    <h2 class="title">Benvenuto nella procedura<br />di firma digitale</h2>

    <p class="description">
      Assicurati di inserire correttamente i dati del firmatario.
    </p>

    <div class="file-container">

      <div class="file-container-text">
        Visualizza anteprima documento: &nbsp;
      </div>

      <div class="file-container-link">

        <mat-icon>picture_as_pdf</mat-icon>
        <a href="{{ fileUrl }}" [attr.download]="labelFileName" class="file-link">
          {{ labelFileName }}
        </a>

      </div>

    </div>

    <form [formGroup]="signatureForm" (ngSubmit)="onSubmit()">
      <mat-form-field appearance="fill">
        <mat-label>Nome</mat-label>
        <input matInput formControlName="name" required />
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Cognome</mat-label>
        <input matInput formControlName="surname" required />
      </mat-form-field>

      <mat-label style="width: 100%; display: flex; padding-left: 16px;">Numero di Telefono*</mat-label>

      <div class="phone-cntr">

        <mat-form-field style="width: 50%;">
          <mat-select formControlName="prefix">
            <mat-option *ngFor="let prefix of countryPrefixes" [value]="prefix.dial_code">
              {{ prefix.code }} {{ prefix.dial_code }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <input matInput formControlName="phone" required />
        </mat-form-field>

      </div>

      <p class="m-t-0">
        Il firmatario riceverà un codice OTP sul numero indicato.
      </p>
      <button mat-raised-button color="primary" class="btn-block btn-lg m-t-10 m-b-10" type="submit"
        [disabled]="!signatureForm.valid">
        Procedi alla firma
      </button>
    </form>
  </div>

</ng-container>


<ng-template #CheckOtherConditionsTmpl>
  <ng-container *ngIf="urlYouSign != null; else CheckMessageTmpl">

    <div class="digital-signature-notice-cntr">
      <img *ngIf="companyLogoSrc; else logoSkeletonTmpl" alt="homepage" [src]="companyLogoSrc" height="55" />
      <h2 class="title">Procedura di firma interrotta</h2>
      <p class="description">È stata caricata la sessione di firma interrotta precedentemente. Completare la firma oppure, se il firmatario è cambiato, chiedere l'invio di una nuova richiesta di firma a <a href="mailto:Sales.Industrial_Support.it@axpo.com">Sales.Industrial_Support.it@axpo.com</a></p>
     <button mat-raised-button color="primary" class="btn-block btn-lg m-t-10 m-b-10" (click)="showIFrameByUrl()">
        Continua
      </button>

    </div>


  </ng-container>
</ng-template>

<ng-template #CheckMessageTmpl>

  <div class="digital-signature-cntr">
    <img *ngIf="companyLogoSrc; else logoSkeletonTmpl" alt="homepage" [src]="companyLogoSrc" height="55" />
    <h2 class="title" *ngIf="this.message">{{this.message}}</h2>
    <p class="description">
      Per qualsiasi necessità di assistenza, contattaci all'indirizzo mail:
      <strong>sales.industrial_support.it&#64;axpo.com</strong></p>


  </div>
</ng-template>

<div *ngIf="showFrame" id="iframe-container" (click)="disableIframe()"></div>

<!-- Skeleton placeholder mostrato al posto del logo finché companyLogoSrc non è risolto -->
<ng-template #logoSkeletonTmpl>
  <div class="logo-skeleton" aria-hidden="true"></div>
</ng-template>